import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslate } from 'hooks/useTranslate';
import { useCompleteOperationModal } from '../context/CompleteOperationModalContext';

const CompleteOperationModalHeader: FC = () => {
  const { t } = useTranslate();
  const { actions } = useCompleteOperationModal();

  return (
    <Modal.Header>
      <h5 className="modal-title mb-0">{t('GenerateContract')}</h5>

      <a className="close cursor-pointer" onClick={actions.handleCloseModal}>
        <em className="icon ni ni-cross" />
      </a>
    </Modal.Header>
  );
};

export default CompleteOperationModalHeader;
